import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {Voucher} from '../../models/Order';
import {ThemeService} from '../../services/theme-service';

@Component({
  selector: 'app-voucher-card',
  standalone: true,
  template: `
    <div class="relative" [ngStyle]="{ width: width + 'px', height: height + 'px' }">
      <!-- Overlay content -->
      <div class="absolute inset-0 z-10 flex flex-col items-center">
        <div *ngIf="circleTitle" class="absolute top-[94px] h-[120px] flex items-center justify-center w-[200px] text-3xl text-center font-bold">
          {{circleTitle}}
        </div>
        <div *ngIf="!circleTitle" class="absolute top-[132px] h-[120px] flex items-center justify-center w-[120px]">
          <img *ngIf="!logo && voucher?.logo" [src]="voucher?.logo">
          <img *ngIf="logo" [src]="logo">
        </div>
        <div class="absolute flex items-center flex-col justify-evenly"
             [ngClass]="circleTitle ? 'top-[210px] h-[200px]' : 'top-[290px] h-[110px]'"
        >
          <div *ngIf="names" class="mx-4 text-3xl font-bold tabular-nums">
            <div class="" *ngFor="let s of names">{{s}}</div>
          </div>
          <div *ngIf="!names" class="mx-4 text-3xl font-bold">{{voucher?.name}}</div>
          <div class="text-2xl tabular-nums font-bold">{{voucher?.formatted}}</div>
        </div>

        <div class="absolute top-[420px]">
          <div class="text-2xl font-bold text-center"># {{voucher?.set_serial_number}}</div>
          <div class="text-3xl mt-2 p-2 bg-theme-text text-theme-surface rounded-2xl font-bold">{{voucher?.activated}}</div>
        </div>

        <div class="absolute bottom-0">
          <div class="rounded-full bg-theme-surface w-20 h-20 flex items-center justify-center font-bold text-3xl tabular-nums">
            <div *ngIf="valid">{{secLeft}}</div>
            <i *ngIf="!valid" class="far fa-hourglass-clock text-[#a0a0a0] -mr-3"></i>
          </div>
        </div>
      </div>

      <svg width="368" height="648" viewBox="0 0 368 648" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g filter="url(#filter0_d_2442_8030)">
          <mask id="mask0_2442_8030" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="0" width="360" height="640">
            <path d="M28 4H81.817C87.5981 4 92.8006 8.27545 94.6236 14.3927C106.838 55.3808 142.059 85.3746 184 85.3746C225.941 85.3746 261.162 55.3808 273.376 14.3927C275.199 8.27545 280.402 4 286.183 4H340C350.697 4 360 13.6591 360 26.3918V145.706L357.544 148.182C351.356 154.42 351.356 164.481 357.544 170.719L360 173.194V613.608C360 626.341 350.697 636 340 636H288.176C282.077 636 276.671 631.252 275.159 624.673C264.948 580.249 228.216 546.928 184 546.928C139.784 546.928 103.052 580.249 92.841 624.673C91.3288 631.252 85.923 636 79.8239 636H28C17.3034 636 8 626.341 8 613.608V173.194L10.4556 170.719C16.6439 164.481 16.6439 154.42 10.4556 148.182L8 145.706V26.3918C8 13.6591 17.3034 4 28 4Z" fill="#E3DCCF"/>
            <path d="M28 4H81.817C87.5981 4 92.8006 8.27545 94.6236 14.3927C106.838 55.3808 142.059 85.3746 184 85.3746C225.941 85.3746 261.162 55.3808 273.376 14.3927C275.199 8.27545 280.402 4 286.183 4H340C350.697 4 360 13.6591 360 26.3918V145.706L357.544 148.182C351.356 154.42 351.356 164.481 357.544 170.719L360 173.194V613.608C360 626.341 350.697 636 340 636H288.176C282.077 636 276.671 631.252 275.159 624.673C264.948 580.249 228.216 546.928 184 546.928C139.784 546.928 103.052 580.249 92.841 624.673C91.3288 631.252 85.923 636 79.8239 636H28C17.3034 636 8 626.341 8 613.608V173.194L10.4556 170.719C16.6439 164.481 16.6439 154.42 10.4556 148.182L8 145.706V26.3918C8 13.6591 17.3034 4 28 4Z" fill="url(#paint0_linear_2442_8030)"/>
            <path d="M28 4H81.817C87.5981 4 92.8006 8.27545 94.6236 14.3927C106.838 55.3808 142.059 85.3746 184 85.3746C225.941 85.3746 261.162 55.3808 273.376 14.3927C275.199 8.27545 280.402 4 286.183 4H340C350.697 4 360 13.6591 360 26.3918V145.706L357.544 148.182C351.356 154.42 351.356 164.481 357.544 170.719L360 173.194V613.608C360 626.341 350.697 636 340 636H288.176C282.077 636 276.671 631.252 275.159 624.673C264.948 580.249 228.216 546.928 184 546.928C139.784 546.928 103.052 580.249 92.841 624.673C91.3288 631.252 85.923 636 79.8239 636H28C17.3034 636 8 626.341 8 613.608V173.194L10.4556 170.719C16.6439 164.481 16.6439 154.42 10.4556 148.182L8 145.706V26.3918C8 13.6591 17.3034 4 28 4Z" stroke="#403F3E" stroke-width="8"/>
          </mask>
          <g mask="url(#mask0_2442_8030)">
            <rect x="380.058" y="-552.135" width="128" height="1406" transform="rotate(45 380.058 -552.135)" [attr.fill]="stripeColor1"/>
            <rect x="470.567" y="-461.625" width="128" height="1406" transform="rotate(45 470.567 -461.625)" [attr.fill]="primary"/>
            <rect x="561.077" y="-371.115" width="128" height="1406" transform="rotate(45 561.077 -371.115)" [attr.fill]="stripeColor1"/>
            <rect x="651.586" y="-280.606" width="128" height="1406" transform="rotate(45 651.586 -280.606)" [attr.fill]="primary"/>
            <rect x="742.096" y="-190.096" width="128" height="1406" transform="rotate(45 742.096 -190.096)" [attr.fill]="stripeColor1"/>
            <rect x="832.605" y="-99.5864" width="128" height="1406" transform="rotate(45 832.605 -99.5864)" [attr.fill]="primary"/>
            <rect x="923.115" y="-9.07666" width="128" height="1406" transform="rotate(45 923.115 -9.07666)" [attr.fill]="stripeColor1"/>
            <rect x="1013.62" y="81.4329" width="128" height="1406" transform="rotate(45 1013.62 81.4329)" [attr.fill]="primary"/>
            <rect x="923.115" y="353" width="128" height="1406" transform="rotate(45 923.115 353)" [attr.fill]="stripeColor1"/>
            <circle cx="184" cy="191" [attr.r]="circleRaduis" stroke-width="8" [attr.stroke]="primary" [attr.fill]="stripeColor1"/>
            <g opacity="0.95">
              <rect x="120" y="138" width="128" height="105.263" fill="url(#pattern0_2442_8030)"/>
            </g>
            <ng-container *ngIf="circleTitle">
              <mask id="path-13-inside-1_2442_8030" fill="white">
                <path d="M0 210C0 208.895 0.895431 208 2 208H366C367.105 208 368 208.895 368 210V409C368 410.105 367.105 411 366 411H2.00001C0.895441 411 0 410.105 0 409V210Z"/>
              </mask>
              <path d="M0 210C0 208.895 0.895431 208 2 208H366C367.105 208 368 208.895 368 210V409C368 410.105 367.105 411 366 411H2.00001C0.895441 411 0 410.105 0 409V210Z" [attr.fill]="stripeColor1"/>
              <path d="M0 210C0 204.477 4.47715 200 10 200H358C363.523 200 368 204.477 368 210V216C368 216 367.105 216 366 216H2C0.895431 216 0 216 0 216V210ZM368 409C368 414.523 363.523 419 358 419H10C4.47715 419 0 414.523 0 409V403C0 403 0.895431 403 2 403H366C367.105 403 368 403 368 403V409ZM0 411V208V411ZM368 208V411V208Z" [attr.fill]="primary" mask="url(#path-13-inside-1_2442_8030)"/>
            </ng-container>
            <ng-container *ngIf="!circleTitle">
              <mask id="path-13-inside-1_2442_8030" fill="white">
                <path d="M0 283C0 281.895 0.895431 281 2 281H366C367.105 281 368 281.895 368 283V409C368 410.105 367.105 411 366 411H2.00001C0.895441 411 0 410.105 0 409V283Z"/>
              </mask>
              <path d="M0 283C0 281.895 0.895431 281 2 281H366C367.105 281 368 281.895 368 283V409C368 410.105 367.105 411 366 411H2.00001C0.895441 411 0 410.105 0 409V283Z" [attr.fill]="stripeColor1"/>
              <path d="M0 283C0 277.477 4.47715 273 10 273H358C363.523 273 368 277.477 368 283V289C368 289 367.105 289 366 289H2C0.895431 289 0 289 0 289V283ZM368 409C368 414.523 363.523 419 358 419H10C4.47715 419 0 414.523 0 409V403C0 403 0.895431 403 2 403H366C367.105 403 368 403 368 403V409ZM0 411V281V411ZM368 281V411V281Z" [attr.fill]="primary" mask="url(#path-13-inside-1_2442_8030)"/>
            </ng-container>

            <path d="M28 4H81.817C87.5981 4 92.8006 8.27545 94.6236 14.3927C106.838 55.3808 142.059 85.3746 184 85.3746C225.941 85.3746 261.162 55.3808 273.376 14.3927C275.199 8.27545 280.402 4 286.183 4H340C350.697 4 360 13.6591 360 26.3918V145.706L357.544 148.182C351.356 154.42 351.356 164.481 357.544 170.719L360 173.194V613.608C360 626.341 350.697 636 340 636H288.176C282.077 636 276.671 631.252 275.159 624.673C264.948 580.249 228.216 546.928 184 546.928C139.784 546.928 103.052 580.249 92.841 624.673C91.3288 631.252 85.923 636 79.8239 636H28C17.3034 636 8 626.341 8 613.608V173.194L10.4556 170.719C16.6439 164.481 16.6439 154.42 10.4556 148.182L8 145.706V26.3918C8 13.6591 17.3034 4 28 4Z"
                  stroke-width="8" [attr.stroke]="primary"/>
          </g>
        </g>
        <defs>
          <filter id="filter0_d_2442_8030" x="0" y="0" width="368" height="648" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="2"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2442_8030"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2442_8030" result="shape"/>
          </filter>
          <pattern id="pattern0_2442_8030" patternContentUnits="objectBoundingBox" width="1" height="1">
          </pattern>
          <linearGradient id="paint0_linear_2442_8030" x1="184" y1="0" x2="184" y2="640" gradientUnits="userSpaceOnUse">
            <stop offset="0.0224227" stop-color="#FDFDFC"/>
            <stop offset="0.306873" [attr.stop-color]="stripeColor1"/>
          </linearGradient>
        </defs>
      </svg>


    </div>
  `,
  imports: [
    NgStyle,
    NgIf,
    NgForOf,
    NgClass
  ],
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class VoucherCardComponent implements OnInit, OnChanges{
  @Input() logo?: string;
  @Input() secLeft?: string;
  @Input() valid?: boolean;
  @Input() voucher?: Voucher;
  @Input() width = 368;
  @Input() height = 648;
  @Input() stripeColor1 = '#F5F4EF';
  @Input() names?: string[];
  @Input() circleRaduis = 95;
  @Input() circleTitle?: string;

  primary = '';

  constructor(private themeService: ThemeService) { }

  ngOnInit(): void {
    this.calculateColors();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("ItemDetailComponent.ngOnChanges", changes);
    if (changes['valid']) {
      this.calculateColors();
    }
  }

  private calculateColors() {
    const primary = this.themeService.color('primary');
    this.primary = this.valid ? primary : '#a0a0a0';
  }
}
